import { render, staticRenderFns } from "./KisDefectCategories.vue?vue&type=template&id=4705579f"
import script from "./KisDefectCategories.js?vue&type=script&lang=js&external"
export * from "./KisDefectCategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports